import {useFetchData} from 'hooks/api/useFetchData'
import {EmployeeFieldGroup} from 'types/api/settings/employeeFieldGroups/employeeFieldGroup'

export const useFetchEmployeeFieldGroups = () => {
  const path = '/api/employee_field_groups'
  return useFetchData<EmployeeFieldGroup[]>(path, [], {})
}
